import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";

import { green } from "../../../../constants/colors";
import { useTheme } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    verticalAlign: "middle",
  },
  text: {
    fontSize: 15,
    fontFamily: "SFProText-Regular",
    color: theme.palette.mainText,
    marginRight: "8px",
  },
  countContainer: {
    height: "28px",
    width: "28px",
    alignSelf: "center !important",
    borderRadius: 5,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "1px solid green",
  },
  arrow: {
    fontSize: "25px",
    padding: 0,
    margin: 0,
    width: "fit-content",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const TopArrow = ({ className, disabled, onClick, style }) => (
  <svg
    onClick={onClick}
    className={className}
    style={{ ...style, transform: "rotate(-90deg)" }}
    disabled={disabled}
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="12"
    viewBox="0 0 6 12"
  >
    <path id="Path_1787" data-name="Path 1787" d="M6,6,0,0V12Z" fill="#34c759" />
  </svg>
);

const DownArrow = ({ className, disabled, onClick, style }) => (
  <svg
    onClick={onClick}
    className={className}
    style={{ ...style, transform: "rotate(90deg)" }}
    disabled={disabled}
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="12"
    viewBox="0 0 6 12"
  >
    <path
      id="Path_1787"
      data-name="Path 1787"
      d="M16,12l-6,6V6Z"
      transform="translate(-10 -6)"
      fill="#34c759"
    />
  </svg>
);

const NumberInput = ({ value = 0, setValue, disabled }) => {
  const [count, setCount] = useState(value);
  const classes = useStyles();
  const {
    palette: { mainText },
  } = useTheme();

  const up = () => {
    setCount(count + 1);
  };

  const down = () => (count > 0 ? setCount(count - 1) : null);

  useEffect(() => {
    if (count) setValue(count);
  }, [count]);

  return (
    <div className={classes.root}>
      <div className={classes.text} style={{ color: disabled ? "gray" : mainText }}>
        After
      </div>
      <div style={{ display: "flex", flexDirection: "row", marginHorizontal: 8 }}>
        <div className={classes.countContainer} style={{ borderColor: disabled ? "gray" : green }}>
          <div
            className={classes.text}
            style={{ color: disabled ? "gray" : mainText, padding: 0, margin: 0 }}
          >
            {count}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: 0,
            margin: 0,
            height: "28px",
            marginLeft: "8px",
            marginRight: "8px",
          }}
        >
          <div>
            <TopArrow
              onClick={up}
              className={classes.arrow}
              disabled={disabled}
              style={{ color: disabled ? "gray" : green, display: "block" }}
            />
          </div>
          <div>
            <DownArrow
              className={classes.arrow}
              onClick={down}
              disabled={disabled}
              style={{ color: disabled ? "gray" : green, display: "block" }}
            />
          </div>
        </div>
      </div>
      <div
        className={classes.text}
        style={{ color: disabled ? "gray" : mainText, padding: 0, margin: 0 }}
      >
        day(s)
      </div>
    </div>
  );
};

export default NumberInput;
